export class UnitConversionUtils {
    public static readonly HZ_IN_KHZ = 1000;
    public static readonly HZ_IN_MHZ = 1000000;
    public static readonly MILLIS_IN_SECOND = 1000;
    public static readonly MILLIS_IN_MINUTES = 60000;
    public static readonly MILLIS_IN_HOUR = 3600000;

    public static hzToMhz(hzInput: number): number {
        return Number(hzInput / this.HZ_IN_MHZ);
    }
    public static khzToMhz(khzInput: number): number {
        return Number(khzInput / this.HZ_IN_KHZ);
    }
}
